import axios from "axios";
import { safeStorage } from "@/services/safeStorage";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  withCredentials: true,
});

const TOKEN_KEY = "pt_access_token";

export const tokenStore = {
  get: () => safeStorage.get(TOKEN_KEY),
  set: (t) => safeStorage.set(TOKEN_KEY, t),
  clear: () => safeStorage.remove(TOKEN_KEY),
};

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errorMessage(e) {
  return formatApiError(e?.response?.data?.detail) || e?.message;
}
